import type { ComparisonTheme } from './comparisonVisualThemes';

export interface FAQItem {
  question: string;
  answer: string;
}

export interface FAQSectionProps {
  id?: string;
  title: string;
  items: FAQItem[];
  theme?: ComparisonTheme;
}

export default function FAQSection({ id = 'faqs', title, items, theme }: FAQSectionProps) {
  const accent = theme?.primary ?? '#1769ff';
  return (
    <section id={id} className="py-16 lg:py-24 bg-white border-t border-slate-100">
      <div className="max-w-3xl mx-auto px-6">
        <h2 className="text-2xl lg:text-3xl font-bold text-slate-900 tracking-tight mb-3">{title}</h2>
        <p className="text-sm text-slate-500 mb-12 max-w-xl">
          Straight answers for teams evaluating delivery and logistics platforms.
        </p>
        <dl className="divide-y divide-slate-100 border-t border-b border-slate-100">
          {items.map((faq) => (
            <div key={faq.question} className="py-8 first:pt-6 last:pb-6">
              <dt className="flex gap-3 text-base font-semibold text-slate-900 mb-3">
                <span
                  className="flex-shrink-0 w-8 h-8 rounded-xl flex items-center justify-center text-sm font-bold text-white"
                  style={{ backgroundColor: accent }}
                  aria-hidden
                >
                  ?
                </span>
                <span className="pt-1">{faq.question}</span>
              </dt>
              <dd className="pl-11 text-slate-600 leading-relaxed text-[15px]">{faq.answer}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
